import React from 'react';
import { Button, InputNumber, Space, Switch } from 'antd';
import styles from '../../../event-timeline.module.css';

interface MoveParamsProps {
  nodeId: string;
  params: any;
  setParams: (params: any) => void;
}

const SwitchBetweenCamerasParams: React.FC<MoveParamsProps> = ({
  nodeId,
  params,
  setParams,
}) => {
  function onSelectPositionPoint() {
    window.dispatchEvent(
      new CustomEvent('add_position_capture_point', {
        detail: {
          nodeId,
          actionName: 'Switch Between Cameras',
          propertyName: 'New Camera position',
          propertyKey: 'position',
        },
      })
    );
  }

  return (
    <div className={styles.parameterContainer}>
      <Space direction='vertical' style={{ width: '100%' }}>
        <h1 className={styles.h1Label}>
          <span>New Camera position</span>
          <Button
            className={styles.selectPosButton}
            onClick={onSelectPositionPoint}
          >
            Select Point
          </Button>
        </h1>
        <span className={styles.label}>Position X:</span>
        <InputNumber
          value={params.position?.x || 0}
          onChange={(value) =>
            setParams({
              ...params,
              position: {
                ...params.position,
                x: value,
              },
            })
          }
          style={{ width: '100%' }}
        />
        <span className={styles.label}>Position Y:</span>
        <InputNumber
          value={params.position?.y || 0}
          onChange={(value) =>
            setParams({
              ...params,
              position: {
                ...params.position,
                y: value,
              },
            })
          }
          style={{ width: '100%' }}
        />
        <span className={styles.label}>Position Z:</span>
        <InputNumber
          value={params.position?.z || 0}
          onChange={(value) =>
            setParams({
              ...params,
              position: {
                ...params.position,
                z: value,
              },
            })
          }
          style={{ width: '100%' }}
        />
        <div>
          <h3>Show Look At Target:</h3>
          <Switch
            value={params.enableLookAtTarget || ''}
            onChange={(value) =>
              setParams({ ...params, enableLookAtTarget: value })
            }
          />
        </div>
      </Space>
    </div>
  );
};

export default SwitchBetweenCamerasParams;
